import dstv from "../../../assets/images/dstv.jpg";
import startimes from "../../../assets/images/startimes.png";
import gotv from "../../../assets/images/GOtv_Logo.png";
import showmax from '../../../assets/icons/showmax-Icon.png'

const generateBankImageUrl = (service) => {
  switch (service) {
    case "gotv":
      return gotv;
    case "startimes":
      return startimes;
    case "showmax":
      return showmax;
    default:
      return dstv;
  }
};

export default generateBankImageUrl;
